import Vue from 'vue'
import _ from 'lodash'

const config = _.assign(Vue.config, {
	productionTip: false,
	ignoredElements: ['row','column']
})

export default config



// WEBPACK FOOTER //
// ./src/initializers/vue.js